import axios from 'axios'
import { API_ENDPOINT } from '../../../../config'
import store from '../../../../redux/stores/store'
import Validation from '../../../../data/validation/validation'
import { StringValidationRule, NumberValidationRule } from '../../../../data/validation/rules'

const toNullableNumber = (value) => {
    if (value === "" || value === null || typeof value === 'undefined') {
        return null
    }
    return Number(value)
}

const getDefaultState = () => {
    return {
        updatingVisaPackage: false,
        loadingVisaPackage: false,
        id: null,
        name: "",
        category: "",
        keyDescription: Math.random(),
        description: "",
        price: "",
        features: "",
        featured: 0,
        status: 0,
        errors: {},
        flag: {
            type: "",
            text: ""
        }
    }
}

const loadVisaPackage = instance => {
    instance.setState({
        ...instance.state,
        loadingVisaPackage: true
    })
    axios({
        method: 'post',
        url: API_ENDPOINT + "/api/visa-package",
        headers: {
            "Authorization": store.getState().auth.authorization
        },
        data: {
            id: instance.props.match.params.id
        }
    }).then(response => handleLoadVisaPackageResponse(instance, response))
    .catch(error => alert(error))
}

const handleLoadVisaPackageResponse = (instance, response) => {
    if (response.status !== 200) {
        return
    }
    switch (response.data.status) {
        case 200:
            const visaPackage = response.data.data.visaPackage || response.data.data.package || response.data.data.item
            instance.setState({
                ...instance.state,
                loadingVisaPackage: false,
                id: visaPackage.id,
                name: visaPackage.name,
                category: visaPackage.category,
                description: visaPackage.description,
                keyDescription: Math.random(),
                price: visaPackage.price == null ? "" : visaPackage.price,
                features: Array.isArray(visaPackage.features) ? visaPackage.features.join('\n') : (visaPackage.features || ""),
                featured: visaPackage.featured ? 1 : 0,
                status: visaPackage.status,
                flag: {
                    type: "",
                    text: ""
                }
            })
            break
        default:
            instance.setState({
                ...instance.state,
                loadingVisaPackage: false,
                flag: {
                    type: "error",
                    text: response.data.message
                }
            })
    }
}

const isValid = instance => {
    let validation = new Validation()
    let errors = instance.state.errors

    validation.addValidationRule(StringValidationRule, instance.state.name, (error) => errors.name = error, { min: { value: 2, error: "Too short" }, max: { value: 150, error: "Too long" } })
    validation.addValidationRule(StringValidationRule, instance.state.category, (error) => errors.category = error, { min: { value: 2, error: "Too short" }, max: { value: 120, error: "Too long" } })
    validation.addValidationRule(StringValidationRule, instance.state.description, (error) => errors.description = error, { min: { value: 5, error: "Too short" }, max: { value: 100000, error: "Too long" } })
    validation.addValidationRule(StringValidationRule, instance.state.features, (error) => errors.features = error, { min: { value: 0, error: "Too short" }, max: { value: 5000, error: "Too long" } })
    validation.addValidationRule(NumberValidationRule, instance.state.price, (error) => errors.price = error, { min: { value: 0, error: "Too low" }, max: { value: 1000000000, error: "Too high" } })

    validation.addValidationRule(NumberValidationRule, instance.state.featured, (error) => errors.featured = error, { min: { value: 0, error: "Too low" }, max: { value: 1, error: "Too high" } })
    validation.addValidationRule(NumberValidationRule, instance.state.status, (error) => errors.status = error, { min: { value: 0, error: "Too low" }, max: { value: 2, error: "Too high" } })

    let validate = validation.validate()
    instance.setState({
        ...instance.state,
        errors: errors,
        flag: {
            type: validate ? "" : "error",
            text: validate ? "" : "Validation Failure"
        }
    })
    return validate
}

const updateVisaPackage = (instance) => {
    instance.setState({
        ...instance.state,
        updatingVisaPackage: true
    })

    const featuresArray = String(instance.state.features)
        .split('\n')
        .map(item => item.trim())
        .filter(item => item.length > 0)

    axios({
        method: 'post',
        url: API_ENDPOINT + "/api/visa-package/update",
        headers: {
            "Authorization": store.getState().auth.authorization
        },
        data: {
            id: instance.props.match.params.id,
            name: instance.state.name,
            category: instance.state.category,
            description: instance.state.description,
            price: toNullableNumber(instance.state.price),
            features: featuresArray,
            featured: Number(instance.state.featured) === 1,
            status: instance.state.status
        }
    }).then(response => handleUpdateVisaPackageResponse(instance, response.data))
    .catch(error => alert(error))
}

const handleUpdateVisaPackageResponse = (instance, response) => {
    if (response.status !== 200) {
        return
    }
    switch (response.status) {
        case 200:
            instance.setState({
                ...instance.state,
                updatingVisaPackage: false,
                flag: {
                    type: "success",
                    text: "Visa Package Updated"
                }
            })
            break
        default:
            instance.setState({
                ...instance.state,
                updatingVisaPackage: false,
                flag: {
                    type: "error",
                    text: response.message
                }
            })
    }
}

const EditVisaPackageWorker = instance => {
    return {
        getDefaultState: getDefaultState,
        isValid: () => isValid(instance),
        loadVisaPackage: () => loadVisaPackage(instance),
        updateVisaPackage: () => updateVisaPackage(instance)
    }
}

export default EditVisaPackageWorker
